import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, DatePicker, AutoComplete, Upload, message } from "antd";
import { ExperimentOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { FormItem, InputItem, TextAreaItem, DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import { cmmsPost, normFile, fileListAPayload, fechaDiaPayload, momentFechaDia } from "../cmmsComun";

// Alta / edicion de un equipo patron (simulador o analizador) y su calibracion.
// props: visible, patron (null = nuevo), onClose(guardado)
class ModalEquipoPatron extends Component {
    formRef = React.createRef();
    state = { loading: false, archivo: [] };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            const p = this.props.patron;
            this.formRef.current?.resetFields();
            this.setState({ archivo: p?.archivo || [] });
            if (p)
                this.formRef.current?.setFieldsValue({
                    clave: p.clave,
                    tipo: p.tipo,
                    marca: p.marca,
                    modelo: p.modelo,
                    numeroSerie: p.numeroSerie,
                    certificado: p.certificado,
                    fechaCalibracion: momentFechaDia(moment, p.fechaCalibracion),
                    proximaCalibracion: momentFechaDia(moment, p.proximaCalibracion),
                    notas: p.notas,
                });
        }
    }

    // Al poner la fecha de calibracion se propone la proxima a un año (si no hay una).
    onValuesChange = (cambios) => {
        if (cambios.fechaCalibracion && !this.formRef.current?.getFieldValue("proximaCalibracion"))
            this.formRef.current?.setFieldsValue({ proximaCalibracion: cambios.fechaCalibracion.clone().add(1, "year") });
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "guardarEquipoPatronCMMS", {
                ...values,
                id: this.props.patron?._id || null,
                fechaCalibracion: fechaDiaPayload(values.fechaCalibracion),
                proximaCalibracion: fechaDiaPayload(values.proximaCalibracion),
                archivo: (await fileListAPayload(this.state.archivo))[0] || null,
            });
            if (res.data.success === 2) {
                message.success("Equipo patrón guardado");
                this.props.onClose(true);
            } else message.error(res.data.message || "No se pudo guardar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <ModalFormCMMS
                titulo={this.props.patron ? "Editar equipo patrón" : "Nuevo equipo patrón"}
                subtitulo="Simulador o analizador con el que se verifican los equipos. Su calibración se imprime en cada certificado."
                icono={<ExperimentOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />}
                visible={this.props.visible}
                loading={this.state.loading}
                onCancel={() => this.props.onClose(false)}
                formRef={this.formRef}
                name="equipoPatronCMMS"
                onFinish={this.onFinish}
                onValuesChange={this.onValuesChange}
                width={760}
            >
                <DynamicCardForm title="Equipo" xs={24}>
                    <Row gutter={12}>
                        <Col xs={24} md={8}>
                            <FormItem label="Clave" name="clave" max={40} tooltip="Identificador interno del equipo patrón (ej. EP-01). No se repite; sale en el certificado y sirve para buscarlo al emitir.">
                                <InputItem placeholder="Ej. EP-01" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="Tipo" name="tipo" tooltip="Cómo se llama en el certificado (Simulador paciente, Analizador...).">
                                <AutoComplete options={[{ value: "Simulador paciente" }, { value: "Analizador" }]} placeholder="Simulador paciente" filterOption={(i, o) => o.value.toLowerCase().includes(String(i).toLowerCase())} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="Marca" name="marca">
                                <InputItem placeholder="Ej. Pronk Technologies" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="Modelo" name="modelo" required max={80}>
                                <InputItem placeholder="Ej. SimCube SC-5" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8}>
                            <FormItem label="No. de serie" name="numeroSerie">
                                <InputItem placeholder="Ej. 8790" />
                            </FormItem>
                        </Col>
                    </Row>
                </DynamicCardForm>
                <DynamicCardForm title="Calibración" xs={24}>
                    <Row gutter={12}>
                        <Col xs={24} md={8}>
                            <FormItem label="Certificado de calibración" name="certificado" tooltip="Folio del certificado que emitió el laboratorio.">
                                <InputItem placeholder="Ej. 8790-003" />
                            </FormItem>
                        </Col>
                        <Col xs={12} md={8}>
                            <FormItem label="Fecha de calibración" name="fechaCalibracion">
                                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                            </FormItem>
                        </Col>
                        <Col xs={12} md={8}>
                            <FormItem label="Próxima calibración" name="proximaCalibracion" tooltip="Se propone a un año. Con ella se avisa cuando el equipo patrón está por vencer.">
                                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                            </FormItem>
                        </Col>
                        <Col xs={24}>
                            <div style={{ marginBottom: 4, fontWeight: 500 }}>Certificado del laboratorio (PDF o imagen)</div>
                            <Upload maxCount={1} accept="application/pdf,image/png,image/jpeg" fileList={this.state.archivo} beforeUpload={() => false} onChange={(e) => this.setState({ archivo: normFile(e) })}>
                                <ButtonItem type="default" htmlType="button" icon={<UploadOutlined />}>
                                    Adjuntar
                                </ButtonItem>
                            </Upload>
                        </Col>
                        <Col xs={24} style={{ marginTop: 10 }}>
                            <FormItem label="Notas" name="notas">
                                <TextAreaItem rows={2} placeholder="Opcional" />
                            </FormItem>
                        </Col>
                    </Row>
                </DynamicCardForm>
            </ModalFormCMMS>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEquipoPatron);
